import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FastagReKyV from './FastagReKyV';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FastagReKyV);
